// extracted by mini-css-extract-plugin
export default {"wrapper":"_37XLUnKxj-xYyc5bHaSdwQ"};